// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import SnackMessages from './core/SnackMessages';
import TwoFactorCode from './ui/TwoFactorCode';

import LoginLogo from './images/rubyNavLogo.png';

import * as coreSelectors from './core/selectors';
import * as coreActions from './core/actions';

const styles = theme => ({
  root : {
    backgroundImage: theme.brandingColors.loginGradient,
    backgroundColor: theme.palette.secondary.main,
    position : 'fixed',
    top: 0, 
    bottom: 0,
    right: 0,
    left: 0, 
  },
  dialog : {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 25,
    color: theme.palette.primary.contrastText,
    padding: 25,
    width: 400,
  },
  codeBox : {
    width: '1em',
    padding: 5,
    color: theme.palette.primary.contrastText,
    ...theme.typography.h6,
    borderBottom: '2px solid white',
  },
});


/*
 * Screen displayed before credentials have been established
 */

class TwoFactorScreen extends Component {
  constructor(props) {
    super(props);
    this.buttonRef =  React.createRef();
  }
  
  state = {
    digits : [ '', '', '', '', '', '',],
    codeSent : false,
    usedEmail : false,
    sendingCode : false,
    verifyEnabled : false,
  }

  componentDidUpdate() {
    let all=true;
    for(let i=0; i<6; i++) {
      if (!this.state.digits[i].length > 0) {
        all=false;
      }
    }
    if (this.state.verifyEnabled !== all) {
      this.setState({verifyEnabled: all});
      return;
    }
  }

  sendCode = (email, resend) => {
    this.setState({sendingCode : true});
    this.props.sendTwoFactor(email, () => {
      this.setState({sendingCode : false, codeSent: true});
      if (resend) {
        this.props.potsSnackMessage('success',
                                    'A new code has been sent.  The previous one will no longer work.');
      }
    }, () => {
      if (!resend) {
        this.setState({sendingCode : false});
      }
    });
  }

  verifyCode = () => {
    let twoFactorCode = this.state.digits.join('');
    this.props.verifyTwoFactor(twoFactorCode);
  }
  
  
  render() {
    const { user, classes, manualPasswordChange, setManualPasswordChange } = this.props;

    let reason;
    let canCancel = false;
    let emailAllowed = false;
    
    if (user.temporaryPassword === 'Y') {
      reason = 'Welcome!  Since this is a new or just reset password, we need to verify your identity by sending a text to your mobile device.';
    }
    
    if (user.temporaryPassword !== 'Y' &&
        user.twoFactor === 'Y' &&
        user.sessionTwoFactor === 'N') {
      reason = 'This user is configured to require two factor verification on all new logins by sending a code to your mobile phone or email.';
      emailAllowed = true;
    } else {
      if (manualPasswordChange) {
        reason = 'To change your password, we must first send a verification code to your mobile phone or email.';
        emailAllowed = true;
        canCancel = true;
      }
    }
    
    if (!this.state.codeSent) {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'  >
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={2}
                            justify='center'
                            alignItems='center'
                            direction='column'>
                <MuiCore.Grid item xs={12}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={12}>
                  <MuiCore.Typography style={{ textAlign: 'center'}}
                                      variant='h6'>{reason}</MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={12}>
                  <MuiCore.Grid container spacing={1}>
                    <MuiCore.Grid item>
                      <MuiCore.Button
                        disabled={this.state.sendingCode}
                        onClick={() => this.sendCode(false, false)}>
                        Send Text
                      </MuiCore.Button>
                    </MuiCore.Grid>
                    <MuiCore.Hidden xlDown={!emailAllowed}>
                      <MuiCore.Grid item>
                        <MuiCore.Button
                          disabled={this.state.sendingCode}
                          onClick={() => this.sendCode(true,false)}>
                          Send Email
                        </MuiCore.Button>
                      </MuiCore.Grid>
                    </MuiCore.Hidden>
                    <MuiCore.Hidden xlDown={!canCancel}>
                      <MuiCore.Grid item>
                        <MuiCore.Button
                          variant='text'
                          disabled={this.state.sendingCode}
                          onClick={() => setManualPasswordChange(false)}>
                          Cancel
                        </MuiCore.Button>
                      </MuiCore.Grid>
                    </MuiCore.Hidden>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'  >
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={2}
                            justify='center'
                            alignItems='center'
                            direction='column'>
                <MuiCore.Grid item xs={12}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={12}>
                  <MuiCore.Typography style={{ textAlign: 'center'}}
                                      variant='h6'>Enter the code you received.</MuiCore.Typography>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12}>
                  <MuiCore.Grid item xs={12}>
                    <TwoFactorCode digits={this.state.digits}
                                   onChange={(digits) => this.setState({digits})}
                                   nextRef={this.buttonRef}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                
                <MuiCore.Grid style={{paddingTop : 40}} item xs={12}>
                  <MuiCore.Grid container spacing={1}>
                    <MuiCore.Grid item>
                      <MuiCore.Button ref={this.buttonRef}
                                      disabled={!this.state.verifyEnabled}
                                      onClick={this.verifyCode}>
                        Verify Code
                      </MuiCore.Button>
                    </MuiCore.Grid>
                    <MuiCore.Grid item>
                      <MuiCore.Button variant='text'
                                      disabled={this.state.sendingCode}
                                      onClick={() => this.sendCode(this.state.usedEmail, true)}>
                        Resend Code
                      </MuiCore.Button>                      
                    </MuiCore.Grid>
                    <MuiCore.Hidden xlDown={!canCancel}>
                      <MuiCore.Grid item>
                        <MuiCore.Button
                          variant='text'
                          disabled={this.state.sendingCode}
                          onClick={() => setManualPasswordChange(false)}>
                          Cancel
                        </MuiCore.Button>
                      </MuiCore.Grid>
                    </MuiCore.Hidden>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>);
    }
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    manualPasswordChange : coreSelectors.getManualPasswordChange(state),
  });
};

const mapDispatchToProps = {
  postSnackMessage : coreActions.postSnackMessage,
  sendTwoFactor : coreActions.sendTwoFactor,
  verifyTwoFactor : coreActions.verifyTwoFactor,
  setManualPasswordChange : coreActions.setManualPasswordChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TwoFactorScreen));

